module.exports = __webpack_public_path__ + "33778156d8fc9f5161b26768f0b69de9.png";